(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-banner-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBSlider(root) {
    if (!root || root.dataset.ffBsInit === 'true') return;
    root.dataset.ffBsInit = 'true';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ff-bslider-slide]'));
    if (slides.length <= 1) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ff-bslider-dot]'));
    var prevBtn = root.querySelector('[data-ff-bslider-prev]');
    var nextBtn = root.querySelector('[data-ff-bslider-next]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayOn = root.dataset.autoplay === 'true' && !reduce;
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var current = 0, timer = null, paused = false;

    function apply(next) {
      slides.forEach(function (s, i) {
        var active = i === next;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        var link = s.querySelector('.ff-bslider__link');
        if (link) { if (active) link.removeAttribute('tabindex'); else link.setAttribute('tabindex', '-1'); }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === next); });
    }
    function goTo(i) { var n = ((i % slides.length) + slides.length) % slides.length; if (n === current) return; current = n; apply(current); }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function start() { if (!autoplayOn || paused || timer) return; timer = setInterval(function () { if (!document.hidden && !paused) next(); }, speed); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.dataset.index, 10) || 0); restart(); }); });

    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { paused = false; start(); } });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else if (!paused) start(); });
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); restart(); } else if (e.key === 'ArrowRight') { e.preventDefault(); next(); restart(); } });

    var tx = 0, ty = 0, touching = false;
    root.addEventListener('touchstart', function (e) { if (!e.touches.length) return; tx = e.touches[0].clientX; ty = e.touches[0].clientY; touching = true; paused = true; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (!touching) return; touching = false;
      var ex = e.changedTouches.length ? e.changedTouches[0].clientX : tx;
      var ey = e.changedTouches.length ? e.changedTouches[0].clientY : ty;
      var dx = ex - tx, dy = ey - ty;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) next(); else prev(); }
      paused = false; restart();
    }, { passive: true });

    apply(0); start();
  }
  function initAll() { document.querySelectorAll('[data-ff-bslider]').forEach(initBSlider); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-ff-bslider]'); if (s) { s.dataset.ffBsInit = ''; initBSlider(s); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hero-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeroSlider(root) {
    if (!root || root.dataset.ffHeroInit === 'true') return;
    root.dataset.ffHeroInit = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ff-hero-slide]'));
    if (slides.length <= 1) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ff-hero-dot]'));
    var prevBtn = root.querySelector('[data-ff-hero-prev]');
    var nextBtn = root.querySelector('[data-ff-hero-next]');

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayOn = root.dataset.autoplay === 'true' && !reduceMotion;
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;

    var current = 0;
    var timer = null;
    var paused = false;

    function applyState(next, prevIndex) {
      slides.forEach(function (slide, i) {
        var active = i === next;
        slide.classList.toggle('is-active', active);
        slide.classList.toggle('is-prev', i === prevIndex && !active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        var cta = slide.querySelector('.ff-hero-slider__cta');
        if (cta && cta.tagName === 'A') {
          if (active) { cta.removeAttribute('tabindex'); } else { cta.setAttribute('tabindex', '-1'); }
        }
      });
      dots.forEach(function (dot, i) {
        var active = i === next;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function goTo(index) {
      var total = slides.length;
      var next = ((index % total) + total) % total;
      if (next === current) return;
      var prevIndex = current;
      current = next;
      applyState(current, prevIndex);
    }

    function nextSlide() { goTo(current + 1); }
    function prevSlide() { goTo(current - 1); }

    function start() {
      if (!autoplayOn || paused || timer) return;
      timer = window.setInterval(function () {
        if (!document.hidden && !paused) nextSlide();
      }, speed);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }
    function restart() { stop(); start(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { prevSlide(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { nextSlide(); restart(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.index, 10) || 0;
        goTo(idx);
        restart();
      });
    });

    // Pause on hover / focus within
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) { paused = false; start(); }
    });

    // Pause when tab hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else if (!paused) { start(); }
    });

    // Keyboard arrows when viewport focused
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); prevSlide(); restart(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); nextSlide(); restart(); }
    });

    // Touch swipe
    var touchX = 0;
    var touchY = 0;
    var touching = false;
    root.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
      touching = true;
      paused = true;
      stop();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (!touching) return;
      touching = false;
      var endX = (e.changedTouches && e.changedTouches.length) ? e.changedTouches[0].clientX : touchX;
      var endY = (e.changedTouches && e.changedTouches.length) ? e.changedTouches[0].clientY : touchY;
      var dx = endX - touchX;
      var dy = endY - touchY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) nextSlide(); else prevSlide();
      }
      paused = false;
      restart();
    }, { passive: true });

    // Init first slide state + autoplay
    applyState(0, -1);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-ff-hero-slider]').forEach(initHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var slider = e.target.querySelector('[data-ff-hero-slider]');
    if (slider) { slider.dataset.ffHeroInit = ''; initHeroSlider(slider); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (!root || root.dataset.ffPcarInit === 'true') return;
      root.dataset.ffPcarInit = 'true';

      var track = root.querySelector('[data-ff-pcar-track]');
      var prev = root.querySelector('[data-ff-pcar-prev]');
      var next = root.querySelector('[data-ff-pcar-next]');
      if (!track) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function step() {
        var item = track.querySelector('.ff-pcar__item');
        if (item) {
          var styles = window.getComputedStyle(track);
          var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
          return item.getBoundingClientRect().width + gap;
        }
        return track.clientWidth * 0.8;
      }

      function scrollByCards(dir) {
        track.scrollBy({
          left: dir * step(),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      function updateArrows() {
        if (!prev || !next) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var x = track.scrollLeft;
        prev.disabled = x <= 1;
        next.disabled = x >= maxScroll - 1;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          scrollByCards(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollByCards(1);
        });
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateArrows);
      }, { passive: true });

      window.addEventListener('resize', function () {
        window.requestAnimationFrame(updateArrows);
      }, { passive: true });

      updateArrows();
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('[data-ff-pcar]');
      nodes.forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-promo-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPromoCta(root) {
      if (!root || root.dataset.ffPromoCtaInit === 'true') return;
      root.dataset.ffPromoCtaInit = 'true';

      var btn = root.querySelector('[data-ff-promo-copy]');
      if (!btn) return;

      var textEl = btn.querySelector('[data-ff-promo-copy-text]');
      var labelCopy = btn.getAttribute('data-label-copy') || 'Copiar';
      var labelDone = btn.getAttribute('data-label-done') || 'Copiado';
      var code = btn.getAttribute('data-code') || '';
      var resetTimer = null;

      function showDone() {
        if (textEl) textEl.textContent = labelDone;
        btn.classList.add('is-copied');
        if (resetTimer) clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          if (textEl) textEl.textContent = labelCopy;
          btn.classList.remove('is-copied');
        }, 1800);
      }

      function fallbackCopy(value) {
        var ta = document.createElement('textarea');
        ta.value = value;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
      }

      btn.addEventListener('click', function () {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showDone).catch(function () {
            fallbackCopy(code);
            showDone();
          });
        } else {
          fallbackCopy(code);
          showDone();
        }
      });
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('[data-ff-promo-cta]');
      nodes.forEach(function (node) { initPromoCta(node); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() { this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
        else { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66); requestAnimationFrame(this.hide.bind(this)); }
      } else if (scrollTop <= this.headerBounds.top) { this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this)); }
      this.currentScrollTop = scrollTop;
    }
    hide() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
    reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach((disclosure) => disclosure.close()); }
    closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function() {
    var mega = document.getElementById('ff-mega');
    var overlay = document.getElementById('ff-mega-overlay');
    var subsPanel = document.getElementById('ff-mega-subs');
    var trigger = null;

    var cats = {
      dermocosmetica: { label: "Dermocosmética", url: '/collections/dermocosmetica', subs: [["Cuidado Facial",'cuidado-facial'],["Limpieza Facial",'limpieza-facial'],["Sérums y Tratamientos",'serums-y-tratamientos'],["Contorno de Ojos",'contorno-de-ojos'],["Protección Facial",'proteccion-facial']] },
      cosmetica: { label: "Cosmética", url: '/collections/cosmetica', subs: [["Maquillaje",'maquillaje'],["Manicura y Uñas",'manicura-y-unas'],["Accesorios de Belleza",'accesorios-belleza'],["Tintes",'tintes']] },
      solar: { label: "Solar", url: '/collections/solar', subs: [["Protección Corporal",'proteccion-corporal'],["Solar Infantil",'solar-infantil'],["After Sun",'after-sun'],["Cápsulas Solares",'capsulas-solares'],["Autobronceadores",'autobronceadores']] },
      capilar: { label: "Capilar", url: '/collections/capilar', subs: [["Champú Capilar",'champu-capilar'],["Tratamientos Capilares",'tratamientos-capilares'],["Cabello",'cabello'],["Cepillos y Peines",'cepillos-y-peines']] },
      corporal: { label: "Corporal e Higiene", url: '/collections/corporal', subs: [["Higiene",'higiene'],["Higiene Femenina",'higiene-femenina'],["Incontinencia",'incontinencia']] },
      bucal: { label: "Higiene Bucal", url: '/collections/higiene-bucal', subs: [["Pasta Dental",'pasta-dental'],["Colutorios",'colutorios'],["Cepillos Dentales",'cepillos-dentales'],["Hilo Dental",'hilo-dental'],["Prótesis Dental",'protes-dental']] },
      bebe: { label: "Bebé e Infantil", url: '/collections/bebe-e-infantil', subs: [["Alimentación de Bebé",'alimentacion-de-bebe'],["Accesorios de Bebé",'accesorios-de-bebe'],["Salud de Bebé",'salud-de-bebe'],["Higiene de Bebé",'higiene-de-bebe'],["Bebé y Mamá",'bebe-y-mama']] },
      suplementos: { label: "Nutrición y Suplementos", url: '/collections/nutricion-y-suplementos', subs: [["Vitaminas y Minerales",'vitaminas-y-minerales'],["Energía y Vitalidad",'energia-y-vitalidad'],["Probióticos",'probioticos'],["Sueño y Relax",'sueno-y-relax'],["Colágeno para Articulaciones",'colageno-para-articulaciones']] },
      botiquin: { label: "Botiquín", url: '/collections/botiquin', subs: [["Antisépticos",'antisepticos'],["Apósitos y Tiritas",'apositos-y-tiritas'],["Vendajes",'vendajes'],["Material Estéril",'material-esteril'],["Material Sanitario",'material-sanitario']] },
      ortopedia: { label: "Ortopedia y Movilidad", url: '/collections/ortopedia', subs: [["Movilidad",'movilidad'],["Muñequeras",'munequeras'],["Rodilleras",'rodilleras'],["Tobilleras",'tobilleras'],["Medias de Compresión",'medias-de-compresion'],["Fajas para la Espalda",'fajas-para-la-espalda'],["Plantillas para los Pies",'plantillas-para-los-pies']] },
      diagnostico: { label: "Diagnóstico", url: '/collections/diagnostico', subs: [["Tests Rápidos",'tests-rapidos'],["Tensión y Temperatura",'tension-y-temperatura'],["Glucemia",'glucemia']] },
      // Estas cinco salían en la columna izquierda pero no estaban aquí, así que
      // al pasar el ratón por encima el panel de la derecha se quedaba con la
      // categoría anterior. No tienen subcategorías: son de un solo nivel.
      optica: { label: "Óptica", url: '/collections/optica', subs: [] },
      sexologia: { label: "Sexología", url: '/collections/sexologia', subs: [] },
      aromaterapia: { label: "Aromaterapia y Homeopatía", url: '/collections/aromoterapia-y-hemeopatia', subs: [] },
      mascotas: { label: "Mascotas", url: '/collections/mascotas', subs: [] },
      parafarmacia: { label: "Parafarmacia", url: '/collections/parafarmacia', subs: [] }
    };

    function renderSubs(key) {
      var cat = cats[key];
      if (!cat) return;
      var subItems = cat.subs.map(function(s) {
        return '<a href="/collections/' + s[1] + '" class="ff-mega-sub-item"><svg class="ff-mega-sub-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg><span class="ff-mega-sub-text">' + s[0] + '</span></a>';
      }).join('');
      var cabecera = '<div class="ff-mega-subs-header"><span class="ff-mega-subs-title">' + cat.label + '</span><a href="' + cat.url + '" class="ff-mega-subs-all">Ver todo →</a></div>';
      // Una categoría sin subcategorías no puede dejar el panel con lo anterior:
      // se enseña un acceso directo a la colección y se entiende qué pasa.
      var cuerpo = cat.subs.length
        ? '<div class="ff-mega-sub-grid">' + subItems + '</div>'
        : '<a href="' + cat.url + '" class="ff-mega-sub-item ff-mega-sub-item--solo"><svg class="ff-mega-sub-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg><span class="ff-mega-sub-text">Ver todo en ' + cat.label + '</span></a>';
      subsPanel.innerHTML = cabecera + cuerpo;
    }

    document.querySelectorAll('.ff-mega-cat-item').forEach(function(item) {
      item.addEventListener('mouseenter', function(e) {
        document.querySelectorAll('.ff-mega-cat-item').forEach(function(i) { i.classList.remove('ff-active'); });
        this.classList.add('ff-active');
        renderSubs(this.dataset.key);
        e.preventDefault();
      });
      item.addEventListener('click', function(e) {
        if (subsPanel.innerHTML && this.classList.contains('ff-active')) {
          window.location.href = this.href;
        } else {
          e.preventDefault();
          document.querySelectorAll('.ff-mega-cat-item').forEach(function(i) { i.classList.remove('ff-active'); });
          this.classList.add('ff-active');
          renderSubs(this.dataset.key);
        }
      });
    });

    renderSubs('cosmetica');
    document.querySelector('.ff-mega-cat-item[data-key="cosmetica"]').classList.add('ff-active');

    function findTrigger() {
      document.querySelectorAll('a, span, button').forEach(function(el) {
        var txt = el.textContent.trim().toLowerCase();
        if ((txt === 'categorías' || txt === 'categorias') && !el.dataset.ffbound) {
          el.dataset.ffbound = '1';
          trigger = el;
          el.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); toggle(); });
        }
      });
    }

    var seccionCabecera = mega.closest('.shopify-section');

    function toggle() { mega.classList.contains('ff-mega--open') ? close() : open(); }
    function open() {
      mega.classList.add('ff-mega--open');
      overlay.classList.add('ff-active');
      // sin esto el velo se queda por debajo de las secciones de la portada
      if (seccionCabecera) seccionCabecera.classList.add('ff-mega-arriba');
      if (trigger) trigger.classList.add('ff-active');
    }
    function close() {
      mega.classList.remove('ff-mega--open');
      overlay.classList.remove('ff-active');
      if (seccionCabecera) seccionCabecera.classList.remove('ff-mega-arriba');
      if (trigger) trigger.classList.remove('ff-active');
    }

    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
    findTrigger();
    setTimeout(findTrigger, 800);
  });

  } catch(e) { console.error(e); }
})();
})();
